/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://8081.localport.dealer.com/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 62);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = React;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = PropTypes;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setClassNames = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Filters undefined, null or empty strings from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 */
var setClassNames = function setClassNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  var classList = new Set(classes);
  return _toConsumableArray(classList).filter(function (c) {
    return c;
  }).join(' ') || null;
};

exports.setClassNames = setClassNames;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_WIDGET_INFO = exports.SET_HOVER = void 0;
var SET_HOVER = 'SET_HOVER';
exports.SET_HOVER = SET_HOVER;
var SET_WIDGET_INFO = 'SET_WIDGET_INFO';
exports.SET_WIDGET_INFO = SET_WIDGET_INFO;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Common", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.Common;
  }
});
Object.defineProperty(exports, "CommonTester", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.CommonTester;
  }
});
Object.defineProperty(exports, "createStore", {
  enumerable: true,
  get: function get() {
    return _wsmCommonData.createStore;
  }
});

var _wsmCommonData = __webpack_require__(58);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _background = __webpack_require__(26);

var _images = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Background =
/*#__PURE__*/
function (_Component) {
  _inherits(Background, _Component);

  function Background(props) {
    var _this;

    _classCallCheck(this, Background);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Background).call(this, props));
    _this.imageRef = _react.default.createRef();
    _this.state = {
      backgroundImage: '/static/images/blank.gif'
    };
    return _this;
  }

  _createClass(Background, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var image = this.imageRef.current;

      if (image && image.complete) {
        this.updateBackgroundImage();
      }
    }
  }, {
    key: "updateBackgroundImage",
    value: function updateBackgroundImage() {
      this.setState({
        backgroundImage: this.imageRef.current.currentSrc || this.imageRef.current.src
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          showImage = _this$props.showImage,
          imageLocation = _this$props.imageLocation,
          imageUrl = _this$props.imageUrl,
          imagePosition = _this$props.imagePosition,
          imageSize = _this$props.imageSize,
          backgroundColor = _this$props.backgroundColor,
          backgroundGradient = _this$props.backgroundGradient,
          backgroundRepeat = _this$props.backgroundRepeat,
          backgroundTransitionProperty = _this$props.backgroundTransitionProperty,
          backgroundTransitionTimingFunction = _this$props.backgroundTransitionTimingFunction,
          backgroundTransitionDuration = _this$props.backgroundTransitionDuration,
          foregroundImageCircle = _this$props.foregroundImageCircle,
          foregroundImageHeight = _this$props.foregroundImageHeight,
          foregroundImageWidth = _this$props.foregroundImageWidth,
          foregroundImageMargin = _this$props.foregroundImageMargin,
          foregroundImagePadding = _this$props.foregroundImagePadding,
          foregroundImageAlignment = _this$props.foregroundImageAlignment;
      var backgroundImage = this.state.backgroundImage;
      var hasBackground = showImage === false && imageLocation !== 'foreground' && (backgroundColor !== '' || backgroundGradient !== '');
      var hasResponsiveImage = (0, _images.isResponsiveImageType)(imageUrl, imageLocation);

      if (showImage || hasBackground) {
        return _react.default.createElement("div", {
          className: (0, _background.setBackgroundClassNames)(imageLocation, foregroundImageCircle, foregroundImageMargin, foregroundImagePadding, foregroundImageAlignment, backgroundColor, backgroundTransitionProperty, backgroundTransitionTimingFunction, backgroundTransitionDuration),
          style: (0, _background.setBackgroundStyles)(showImage, imageLocation, imageUrl, imagePosition, imageSize, backgroundGradient, backgroundRepeat, foregroundImageHeight, foregroundImageWidth, hasResponsiveImage, backgroundImage)
        }, hasResponsiveImage && _react.default.createElement("img", {
          ref: this.imageRef,
          alt: "",
          hidden: true,
          role: "presentation",
          className: "lazy-image dynamic-resize responsive-image d-none",
          "data-src": imageUrl,
          onLoad: this.updateBackgroundImage.bind(this)
        }));
      }

      return null;
    }
  }]);

  return Background;
}(_react.Component);

Background.defaultProps = {
  imageLocation: '',
  imageUrl: '',
  imagePosition: '',
  imageSize: '',
  backgroundColor: '',
  backgroundGradient: '',
  backgroundRepeat: '',
  backgroundTransitionProperty: '',
  backgroundTransitionTimingFunction: '',
  backgroundTransitionDuration: '',
  foregroundImageCircle: false,
  foregroundImageHeight: 0,
  foregroundImageWidth: 0,
  foregroundImageMargin: '',
  foregroundImagePadding: '',
  foregroundImageAlignment: ''
};
Background.propTypes = {
  showImage: _propTypes.default.bool.isRequired,
  imageLocation: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  imagePosition: _propTypes.default.string,
  imageSize: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  backgroundGradient: _propTypes.default.string,
  backgroundRepeat: _propTypes.default.string,
  backgroundTransitionProperty: _propTypes.default.string,
  backgroundTransitionTimingFunction: _propTypes.default.string,
  backgroundTransitionDuration: _propTypes.default.string,
  foregroundImageCircle: _propTypes.default.bool,
  foregroundImageHeight: _propTypes.default.number,
  foregroundImageWidth: _propTypes.default.number,
  foregroundImageMargin: _propTypes.default.string,
  foregroundImagePadding: _propTypes.default.string,
  foregroundImageAlignment: _propTypes.default.string
};
var _default = Background;
exports.default = _default;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerTrackingEvent = void 0;

var _trackEvent = __webpack_require__(33);

/**
 * Sets the event object for the Google anlytics event
 * Passes the object to the `trackGoogleAnalyticsEvent` helper function
 * @param {string} element - A string value for element
 * @param {string} elementCTA - A string value for elementCTA
 * @param {string} result - A string value for result
 * @param {string} windowId - A string value for windowId
 */
var triggerTrackingEvent = function triggerTrackingEvent(element, elementCTA, result, windowId) {
  var eventData = {
    element: element,
    elementCTA: elementCTA,
    result: result,
    windowId: windowId
  };
  var _global = global,
      window = _global.window;
  return (0, _trackEvent.trackGoogleAnalyticsEvent)(eventData, window);
};

exports.triggerTrackingEvent = triggerTrackingEvent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setImageDimension = exports.hasImpolicy = exports.isDealerImage = void 0;

/**
 * Determines if a specific URL matches conditional checks
 * Returns a boolean that checks for specific Dealer.com image URLs
 * @param {string} url - A URL string value
 */
var isDealerImage = function isDealerImage(url) {
  var domainRegex = /(.*\/\/.*)?(pictures|images|static)(\.)([^.]+\.)?dealer\.com(.*)/;
  return domainRegex.test(url) || url.startsWith('/static/');
};
/**
 * Determines if a specific URL contains our `impolicy` URL parameter
 * Returns a boolean that checks for impolicy param
 * @param {string} imageUrl - A URL string value
 */


exports.isDealerImage = isDealerImage;

var hasImpolicy = function hasImpolicy(imageUrl) {
  return imageUrl ? imageUrl.includes('impolicy') : false;
};
/**
 * Sets the proper image dimension based on if it should be equal height and width
 * Returns an image dimension integer value based on the `dimensionType`
 * @param {string} dimensionType - A string value of 'height' or 'width'
 * @param {string} deviceType - A string value of 'DESKTOP' or 'MOBILE' to set appropriate fallback values
 * @param {integer} height - A number value setting the height
 * @param {integer} width - A number value setting the width
 * @param {boolean} isEqualDimensions - A boolean determining if the dimensions should be equal
 */


exports.hasImpolicy = hasImpolicy;

var setImageDimension = function setImageDimension() {
  var dimensionType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'width';
  var deviceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DESKTOP';
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var width = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var isEqualDimensions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var imageDimension = dimensionType.toLowerCase().trim() === 'width' ? width : height;

  if (isEqualDimensions) {
    if (!height && width || width && height !== width) {
      imageDimension = width;
    } else if (!width && height) {
      imageDimension = height;
    } else if (height !== width || width === 0 && height === 0) {
      imageDimension = deviceType === 'DESKTOP' ? 192 : 160;
    }
  }

  return imageDimension;
};

exports.setImageDimension = setImageDimension;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setImageUrl = exports.isResponsiveImageType = exports.isResizable = void 0;

var _format = __webpack_require__(28);

var _images = __webpack_require__(8);

/**
 * Determines that image URL meets criteria for resize adjustments
 * Returns a boolean that checks for dealer.com image domain and no impolicy param included
 * @param {string} imageUrl - A URL string value
 */
var isResizable = function isResizable(imageUrl) {
  return (0, _images.isDealerImage)(imageUrl) && !(0, _images.hasImpolicy)(imageUrl);
};
/**
 * Determines if image URL and image location allow responsive image
 * Returns a boolean that checks `imageLocation` and if it should be resizable
 * @param {string} imageUrl - A URL string value
 * @param {string} imageLocation - A string value for defining foreground param configuraiton
 */


exports.isResizable = isResizable;

var isResponsiveImageType = function isResponsiveImageType(imageUrl, imageLocation) {
  return imageLocation !== 'foreground' && isResizable(imageUrl);
};
/**
 * Formats url of the imageUrl based on height and width parameters
 * Returns resized image URL
 * @param {string} imageUrl - A URL string value
 * @param {number} imageHeight - A number value for height
 * @param {number} imageWidth - A number value for width
 * @param {string} imageLocation - A string value for defining foreground param configuraiton
 */


exports.isResponsiveImageType = isResponsiveImageType;

var setImageUrl = function setImageUrl(imageUrl, imageHeight, imageWidth, imageLocation) {
  if (imageLocation === 'foreground' && isResizable(imageUrl)) {
    var resizeMethod = imageHeight && imageWidth ? 'downsize_crop' : 'downsize'; // If imageHeight is not set, return early so the unveil/resizer
    // tool will take over and set the appropriate dimensions.

    if (!imageHeight) {
      return imageUrl;
    } // 'impolicy' parameter triggers Akamai resizing


    var resizedImage = "".concat(imageUrl).concat((0, _format.setParamSeparator)(imageUrl), "impolicy=").concat(resizeMethod);

    if (imageHeight) {
      resizedImage = "".concat(resizedImage, "&h=").concat(imageHeight);
    }

    if (imageWidth) {
      resizedImage = "".concat(resizedImage, "&w=").concat(imageWidth);
    }

    return resizedImage;
  } else if (imageUrl) {
    return imageUrl;
  }

  return null;
};

exports.setImageUrl = setImageUrl;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CASE_SENSITIVE_TAG_NAMES = __webpack_require__(44).CASE_SENSITIVE_TAG_NAMES;

var caseSensitiveTagNamesMap = {};
var tagName;
for (var i = 0, len = CASE_SENSITIVE_TAG_NAMES.length; i < len; i++) {
    tagName = CASE_SENSITIVE_TAG_NAMES[i];
    caseSensitiveTagNamesMap[tagName.toLowerCase()] = tagName;
}

/**
 * Gets case-sensitive tag name.
 *
 * @param  {String}           tagName - The lowercase tag name.
 * @return {String|undefined}
 */
function getCaseSensitiveTagName(tagName) {
    return caseSensitiveTagNamesMap[tagName];
}

/**
 * Formats DOM attributes to a hash map.
 *
 * @param  {NamedNodeMap} attributes - The list of attributes.
 * @return {Object}                  - A map of attribute name to value.
 */
function formatAttributes(attributes) {
    var result = {};
    var attribute;
    // `NamedNodeMap` is array-like
    for (var i = 0, len = attributes.length; i < len; i++) {
        attribute = attributes[i];
        result[attribute.name] = attribute.value;
    }
    return result;
}

/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param  {String} tagName - The lowercase tag name.
 * @return {String}         - The formatted tag name.
 */
function formatTagName(tagName) {
    tagName = tagName.toLowerCase();
    var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
    if (caseSensitiveTagName) {
        return caseSensitiveTagName;
    }
    return tagName;
}

/**
 * Formats the browser DOM nodes to mimic the output of `htmlparser2.parseDOM()`.
 *
 * @param  {NodeList} nodes        - The DOM nodes.
 * @param  {Object}   [parentObj]  - The formatted parent node.
 * @param  {String}   [directive]  - The directive.
 * @return {Object[]}              - The formatted DOM object.
 */
function formatDOM(nodes, parentObj, directive) {
    parentObj = parentObj || null;

    var result = [];
    var node;
    var prevNode;
    var nodeObj;

    // `NodeList` is array-like
    for (var i = 0, len = nodes.length; i < len; i++) {
        node = nodes[i];
        // reset
        nodeObj = {
            next: null,
            prev: result[i - 1] || null,
            parent: parentObj
        };

        // set the next node for the previous node (if applicable)
        prevNode = result[i - 1];
        if (prevNode) {
            prevNode.next = nodeObj;
        }

        // set the node name if it's not "#text" or "#comment"
        // e.g., "div"
        if (node.nodeName[0] !== '#') {
            nodeObj.name = formatTagName(node.nodeName);
            // also, nodes of type "tag" have "attribs"
            nodeObj.attribs = {}; // default
            if (node.attributes && node.attributes.length) {
                nodeObj.attribs = formatAttributes(node.attributes);
            }
        }

        // set the node type
        // e.g., "tag"
        switch (node.nodeType) {
            // 1 = element
            case 1:
                if (nodeObj.name === 'script' || nodeObj.name === 'style') {
                    nodeObj.type = nodeObj.name;
                } else {
                    nodeObj.type = 'tag';
                }
                // recursively format the children
                nodeObj.children = formatDOM(node.childNodes, nodeObj);
                break;
                // 2 = attribute
                // 3 = text
            case 3:
                nodeObj.type = 'text';
                nodeObj.data = node.nodeValue;
                break;
                // 8 = comment
            case 8:
                nodeObj.type = 'comment';
                nodeObj.data = node.nodeValue;
                break;
            default:
                break;
        }

        result.push(nodeObj);
    }

    if (directive) {
        result.unshift({
            name: directive.substring(0, directive.indexOf(' ')).toLowerCase(),
            data: directive,
            type: 'directive',
            next: result[0] ? result[0] : null,
            prev: null,
            parent: parentObj
        });

        if (result[1]) {
            result[1].prev = result[0];
        }
    }

    return result;
}

/**
 * Detects IE with or without version.
 *
 * @param  {Number}  [version] - The IE version to detect.
 * @return {Boolean}           - Whether IE or the version has been detected.
 */
function isIE(version) {
    if (version) {
        return document.documentMode === version;
    }
    return /(MSIE |Trident\/|Edge\/)/.test(navigator.userAgent);
}

/**
 * Export utilities.
 */
module.exports = {
    formatAttributes: formatAttributes,
    formatDOM: formatDOM,
    isIE: isIE
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var hyphenPatternRegex = /-([a-z])/g;
var CUSTOM_PROPERTY_OR_NO_HYPHEN_REGEX = /^--[a-zA-Z0-9-]+$|^[^-]+$/;

/**
 * Converts a string to camelCase.
 *
 * @param  {String} string - The string.
 * @return {String}
 */
function camelCase(string) {
  if (typeof string !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  // custom property or no hyphen found
  if (CUSTOM_PROPERTY_OR_NO_HYPHEN_REGEX.test(string)) {
    return string;
  }

  // convert to camelCase
  return string
    .toLowerCase()
    .replace(hyphenPatternRegex, function(_, character) {
      return character.toUpperCase();
    });
}

/**
 * Swap key with value in an object.
 *
 * @param  {Object}   obj        - The object.
 * @param  {Function} [override] - The override method.
 * @return {Object}              - The inverted object.
 */
function invertObject(obj, override) {
  if (!obj || typeof obj !== 'object') {
    throw new TypeError('First argument must be an object');
  }

  var key;
  var value;
  var isOverridePresent = typeof override === 'function';
  var overrides = {};
  var result = {};

  for (key in obj) {
    value = obj[key];

    if (isOverridePresent) {
      overrides = override(key, value);
      if (overrides && overrides.length === 2) {
        result[overrides[0]] = overrides[1];
        continue;
      }
    }

    if (typeof value === 'string') {
      result[value] = key;
    }
  }

  return result;
}

/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {Object} props   - The props being passed to the element.
 * @return {boolean}
 */
function isCustomComponent(tagName, props) {
  if (tagName.indexOf('-') === -1) {
    return props && typeof props.is === 'string';
  }

  switch (tagName) {
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    case 'annotation-xml':
    case 'color-profile':
    case 'font-face':
    case 'font-face-src':
    case 'font-face-uri':
    case 'font-face-format':
    case 'font-face-name':
    case 'missing-glyph':
      return false;
    default:
      return true;
  }
}

/**
 * @constant {Boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */
var PRESERVE_CUSTOM_ATTRIBUTES = React.version.split('.')[0] >= 16;

module.exports = {
  PRESERVE_CUSTOM_ATTRIBUTES: PRESERVE_CUSTOM_ATTRIBUTES,
  camelCase: camelCase,
  invertObject: invertObject,
  isCustomComponent: isCustomComponent
};


/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = ReactRedux;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _reactDom = __webpack_require__(59);

var _WidgetWrapper = _interopRequireDefault(__webpack_require__(36));

var _store = __webpack_require__(42);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * WARNING: This file is owned by ws-scripts and can not be edited!
 *
 * This is the main entry point for our application when
 * executed in the browser. As such, it has some responsibilities:
 *
 * - Load server side rendered redux state
 * - Create the redux store with that state
 * - Kick off a React hydrate bound to the redux store
 *
 * We load our server side rendered state from an object
 * of the form:
 *
 *	window.DDC = {
 *		WS: {
 *			state: {
 *				"ws-hours": {
 *					"hours1": {STATE}
 *					"hours2": {STATE}
 *				},
 *				"ws-quick-specs": {
 *					"quick-specs1": {STATE}
 *				}
 *			}
 *		}
 *	};
 *
 * In local development, the state will be a JSON object. When
 * loaded from CMS, it will be a string, since that reduces
 * serialization overhead but still avoids string concatenation.
 */
var getFlag = function getFlag(name, defaultValue) {
  if (!window.DDC || !window.DDC.Flags) {
    return defaultValue;
  }

  return window.DDC.Flags[name];
};

var serveBundleFromClientSite = getFlag('serve-osiris-bundle-from-clientsite', false) === true;
var stateParentKey = serveBundleFromClientSite ? 'WS' : 'OSIRIS';

var getWidgetStatesByType = function getWidgetStatesByType(widgetName) {
  if (!window.DDC || !window.DDC[stateParentKey] || !window.DDC[stateParentKey].state || !window.DDC[stateParentKey].state[widgetName]) {
    return {};
  }

  return window.DDC[stateParentKey].state[widgetName];
};

var getWidgetState = function getWidgetState(widgetStates, widgetId) {
  var preloadedState = widgetStates[widgetId];

  if (typeof preloadedState === 'string') {
    preloadedState = JSON.parse(preloadedState);
  }

  return preloadedState;
};

var widgetIdToStore = {};

var initializeWidgets = function initializeWidgets() {
  var widgetStates = getWidgetStatesByType('ws-content-cta');
  var widgetIds = Object.keys(widgetStates);
  widgetIds.forEach(function (widgetId) {
    var store = (0, _store.createStore)(getWidgetState(widgetStates, widgetId));
    widgetIdToStore[widgetId] = store; // When the widget is initially rendered server-side, render.jsx passes outputWrapperDiv
    // to render the widget wrapper div. Here, when hydrating, we pass outputWrapperDiv=false.
    // This is because hydrate takes a DOM element to hydrate into. We can't wrap the widget
    // in an extra div to target because there is a lot of styling in our system that
    // breaks. So, instead, we have to target the widget wrapper div and hydrate the
    // components inside of it.

    (0, _reactDom.hydrate)(React.createElement(_WidgetWrapper.default, {
      outputWrapperDiv: false,
      store: store,
      widgetId: widgetId
    }), document.getElementById("".concat(widgetId, "-app-root"))); // We've initialized. We don't need to keep this data around anymore.
    // Deleting it ensures that we don't accidentally reinitialize later.

    if (serveBundleFromClientSite) {
      delete widgetStates[widgetId];
    }
  });
};

if (serveBundleFromClientSite) {
  initializeWidgets();
} else if (window.DDC && window.DDC.Events && window.DDC.Events['inline-js-available']) {
  initializeWidgets();
} else {
  $(document).on('inlineJSAvailable', initializeWidgets);
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHover = setHover;

var _types = __webpack_require__(3);

function setHover() {
  var isHovered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return {
    type: _types.SET_HOVER,
    payload: {
      isHovered: isHovered
    }
  };
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classes = __webpack_require__(2);

var _analytics = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleClick = function handleClick(event, isClickableDivElement, element, elementCTA, result, windowId) {
  // Disable event to allow clickable wrapper to apply window.location
  if (isClickableDivElement) {
    event.preventDefault();
  }

  (0, _analytics.triggerTrackingEvent)(element, elementCTA, "Navigated to ".concat(result), windowId);
};

var Button = function Button(_ref) {
  var windowId = _ref.windowId,
      target = _ref.target,
      url = _ref.url,
      isClickableDivElement = _ref.isClickableDivElement,
      enableDialogWindow = _ref.enableDialogWindow,
      dialogWindowWidth = _ref.dialogWindowWidth,
      dialogWindowTitleText = _ref.dialogWindowTitleText,
      buttonTransitionProperty = _ref.buttonTransitionProperty,
      buttonTransitionTimingFunction = _ref.buttonTransitionTimingFunction,
      buttonTransitionDuration = _ref.buttonTransitionDuration,
      showButton = _ref.showButton,
      buttonText = _ref.buttonText,
      buttonStyle = _ref.buttonStyle,
      buttonSize = _ref.buttonSize,
      buttonMargin = _ref.buttonMargin,
      buttonAlignment = _ref.buttonAlignment;

  if (showButton && url && buttonText !== '') {
    return _react.default.createElement("a", {
      className: (0, _classes.setClassNames)('btn', enableDialogWindow ? 'dialog' : null, buttonStyle, buttonSize, buttonMargin, buttonAlignment, buttonTransitionProperty, buttonTransitionTimingFunction, buttonTransitionDuration),
      target: target || null,
      id: "".concat(windowId, "-button"),
      href: url,
      "data-modal": enableDialogWindow ? 'true' : null,
      "data-title": enableDialogWindow && dialogWindowTitleText ? dialogWindowTitleText : null,
      "data-width": enableDialogWindow && dialogWindowWidth ? dialogWindowWidth : null,
      onClick: function onClick(event) {
        handleClick(event, isClickableDivElement, 'ws-content-cta button', buttonText, url, windowId);
      }
    }, buttonText);
  }

  return null;
};

Button.defaultProps = {
  target: '',
  enableDialogWindow: false,
  dialogWindowWidth: '',
  dialogWindowTitleText: '',
  buttonTransitionProperty: '',
  buttonTransitionTimingFunction: '',
  buttonTransitionDuration: '',
  buttonStyle: '',
  buttonSize: '',
  buttonMargin: '',
  buttonAlignment: ''
};
Button.propTypes = {
  windowId: _propTypes.default.string.isRequired,
  target: _propTypes.default.string,
  url: _propTypes.default.string.isRequired,
  isClickableDivElement: _propTypes.default.bool.isRequired,
  enableDialogWindow: _propTypes.default.bool,
  dialogWindowWidth: _propTypes.default.string,
  dialogWindowTitleText: _propTypes.default.string,
  buttonTransitionProperty: _propTypes.default.string,
  buttonTransitionTimingFunction: _propTypes.default.string,
  buttonTransitionDuration: _propTypes.default.string,
  showButton: _propTypes.default.bool.isRequired,
  buttonText: _propTypes.default.string.isRequired,
  buttonStyle: _propTypes.default.string,
  buttonSize: _propTypes.default.string,
  buttonMargin: _propTypes.default.string,
  buttonAlignment: _propTypes.default.string
};
var _default = Button;
exports.default = _default;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classes = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Content = function Content(_ref) {
  var showContent = _ref.showContent,
      contentText = _ref.contentText,
      contentSize = _ref.contentSize,
      contentColor = _ref.contentColor,
      contentMargin = _ref.contentMargin,
      contentPadding = _ref.contentPadding,
      contentAlignment = _ref.contentAlignment,
      contentTransitionProperty = _ref.contentTransitionProperty,
      contentTransitionTimingFunction = _ref.contentTransitionTimingFunction,
      contentTransitionDuration = _ref.contentTransitionDuration;

  if (showContent && contentText !== '') {
    return _react.default.createElement("p", {
      className: (0, _classes.setClassNames)(contentSize, contentColor, contentMargin, contentPadding, contentAlignment, contentTransitionProperty, contentTransitionTimingFunction, contentTransitionDuration)
    }, contentText);
  }

  return null;
};

Content.defaultProps = {
  contentSize: '',
  contentColor: '',
  contentMargin: '',
  contentPadding: '',
  contentAlignment: '',
  contentTransitionProperty: '',
  contentTransitionTimingFunction: '',
  contentTransitionDuration: ''
};
Content.propTypes = {
  showContent: _propTypes.default.bool.isRequired,
  contentText: _propTypes.default.string.isRequired,
  contentSize: _propTypes.default.string,
  contentColor: _propTypes.default.string,
  contentMargin: _propTypes.default.string,
  contentPadding: _propTypes.default.string,
  contentAlignment: _propTypes.default.string,
  contentTransitionProperty: _propTypes.default.string,
  contentTransitionTimingFunction: _propTypes.default.string,
  contentTransitionDuration: _propTypes.default.string
};
var _default = Content;
exports.default = _default;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Icon = _interopRequireDefault(__webpack_require__(19));

var _Background = _interopRequireDefault(__webpack_require__(6));

var _Heading = _interopRequireDefault(__webpack_require__(18));

var _Content = _interopRequireDefault(__webpack_require__(16));

var _Button = _interopRequireDefault(__webpack_require__(15));

var _classes = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentWrapper = function ContentWrapper(_ref) {
  var widgetConfiguration = _ref.widgetConfiguration,
      windowId = _ref.windowId,
      isClickableDivElement = _ref.isClickableDivElement,
      headingText = _ref.headingText,
      contentText = _ref.contentText,
      buttonText = _ref.buttonText,
      dialogWindowTitleText = _ref.dialogWindowTitleText,
      target = _ref.target;
  var widgetAlignment = widgetConfiguration.widgetAlignment,
      widgetJustify = widgetConfiguration.widgetJustify,
      widgetMargin = widgetConfiguration.widgetMargin,
      widgetPadding = widgetConfiguration.widgetPadding,
      textAlignment = widgetConfiguration.textAlignment,
      contentWrapperWidth = widgetConfiguration.contentWrapperWidth,
      contentWrapperTransitionProperty = widgetConfiguration.contentWrapperTransitionProperty,
      contentWrapperTransitionTimingFunction = widgetConfiguration.contentWrapperTransitionTimingFunction,
      contentWrapperTransitionDuration = widgetConfiguration.contentWrapperTransitionDuration,
      buttonTransitionProperty = widgetConfiguration.buttonTransitionProperty,
      buttonTransitionTimingFunction = widgetConfiguration.buttonTransitionTimingFunction,
      buttonTransitionDuration = widgetConfiguration.buttonTransitionDuration,
      textColor = widgetConfiguration.textColor,
      imageLocation = widgetConfiguration.imageLocation,
      enableContentOverflowHidden = widgetConfiguration.enableContentOverflowHidden;
  return _react.default.createElement("div", {
    className: (0, _classes.setClassNames)('cta-content', 'd-flex', 'flex-column', 'h-100', 'position-relative', widgetAlignment, widgetJustify, widgetMargin, widgetPadding, textAlignment, textColor, contentWrapperWidth, contentWrapperTransitionProperty, contentWrapperTransitionTimingFunction, contentWrapperTransitionDuration),
    style: enableContentOverflowHidden ? {
      overflow: 'hidden'
    } : null
  }, _react.default.createElement(_Icon.default, widgetConfiguration), imageLocation === 'foreground' && _react.default.createElement(_Background.default, widgetConfiguration), _react.default.createElement(_Heading.default, _objectSpread({}, widgetConfiguration, {
    windowId: windowId,
    headingText: headingText
  })), _react.default.createElement(_Content.default, _objectSpread({}, widgetConfiguration, {
    contentText: contentText
  })), _react.default.createElement(_Button.default, _objectSpread({}, widgetConfiguration, {
    windowId: windowId,
    isClickableDivElement: isClickableDivElement,
    target: target,
    dialogWindowTitleText: dialogWindowTitleText,
    buttonText: buttonText,
    buttonTransitionProperty: buttonTransitionProperty,
    buttonTransitionTimingFunction: buttonTransitionTimingFunction,
    buttonTransitionDuration: buttonTransitionDuration
  })));
};

ContentWrapper.defaultProps = {
  headingText: '',
  contentText: '',
  buttonText: '',
  dialogWindowTitleText: ''
};
ContentWrapper.propTypes = {
  widgetConfiguration: _propTypes.default.shape({
    widgetAlignment: _propTypes.default.string,
    widgetJustify: _propTypes.default.string,
    widgetMargin: _propTypes.default.string,
    widgetPadding: _propTypes.default.string,
    textAlignment: _propTypes.default.string,
    contentWrapperWidth: _propTypes.default.string.isRequired,
    contentWrapperTransitionProperty: _propTypes.default.string.isRequired,
    contentWrapperTransitionTimingFunction: _propTypes.default.string.isRequired,
    contentWrapperTransitionDuration: _propTypes.default.string.isRequired,
    buttonTransitionProperty: _propTypes.default.string.isRequired,
    buttonTransitionTimingFunction: _propTypes.default.string.isRequired,
    buttonTransitionDuration: _propTypes.default.string.isRequired,
    textColor: _propTypes.default.string.isRequired,
    imageLocation: _propTypes.default.string,
    enableContentOverflowHidden: _propTypes.default.bool.isRequired
  }).isRequired,
  windowId: _propTypes.default.string.isRequired,
  isClickableDivElement: _propTypes.default.bool.isRequired,
  target: _propTypes.default.string.isRequired,
  headingText: _propTypes.default.string,
  contentText: _propTypes.default.string,
  buttonText: _propTypes.default.string,
  dialogWindowTitleText: _propTypes.default.string
};
var _default = ContentWrapper;
exports.default = _default;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classes = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading = function Heading(_ref) {
  var showHeading = _ref.showHeading,
      headingText = _ref.headingText,
      headingMargin = _ref.headingMargin,
      headingPadding = _ref.headingPadding,
      headingAlignment = _ref.headingAlignment,
      headingElement = _ref.headingElement,
      headingSize = _ref.headingSize,
      headingColor = _ref.headingColor,
      headingClasses = _ref.headingClasses,
      headingTransitionProperty = _ref.headingTransitionProperty,
      headingTransitionTimingFunction = _ref.headingTransitionTimingFunction,
      headingTransitionDuration = _ref.headingTransitionDuration,
      windowId = _ref.windowId;

  if (showHeading && headingText !== '') {
    var HeadingElement = headingElement;
    return _react.default.createElement(HeadingElement, {
      className: (0, _classes.setClassNames)(headingClasses, headingSize, headingColor, headingMargin, headingPadding, headingAlignment, headingTransitionProperty, headingTransitionTimingFunction, headingTransitionDuration),
      id: "".concat(windowId, "-heading")
    }, headingText);
  }

  return null;
};

Heading.defaultProps = {
  headingMargin: '',
  headingPadding: '',
  headingAlignment: '',
  headingElement: '',
  headingSize: '',
  headingColor: '',
  headingClasses: '',
  headingTransitionProperty: '',
  headingTransitionTimingFunction: '',
  headingTransitionDuration: ''
};
Heading.propTypes = {
  showHeading: _propTypes.default.bool.isRequired,
  headingText: _propTypes.default.string.isRequired,
  headingMargin: _propTypes.default.string,
  headingPadding: _propTypes.default.string,
  headingAlignment: _propTypes.default.string,
  headingElement: _propTypes.default.string,
  headingSize: _propTypes.default.string,
  headingColor: _propTypes.default.string,
  headingClasses: _propTypes.default.string,
  headingTransitionProperty: _propTypes.default.string,
  headingTransitionTimingFunction: _propTypes.default.string,
  headingTransitionDuration: _propTypes.default.string,
  windowId: _propTypes.default.string.isRequired
};
var _default = Heading;
exports.default = _default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _classes = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(_ref) {
  var showIcon = _ref.showIcon,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      iconColor = _ref.iconColor,
      iconMargin = _ref.iconMargin,
      iconPadding = _ref.iconPadding,
      iconAlignment = _ref.iconAlignment;

  if (showIcon && iconName !== '') {
    return _react.default.createElement("i", {
      className: (0, _classes.setClassNames)('ddc-icon', 'line-height-reset', iconName, iconSize, iconColor, iconMargin, iconPadding, iconAlignment)
    });
  }

  return null;
};

Icon.defaultProps = {
  iconSize: '',
  iconColor: '',
  iconMargin: '',
  iconPadding: '',
  iconAlignment: ''
};
Icon.propTypes = {
  showIcon: _propTypes.default.bool.isRequired,
  iconName: _propTypes.default.string.isRequired,
  iconSize: _propTypes.default.string,
  iconColor: _propTypes.default.string,
  iconMargin: _propTypes.default.string,
  iconPadding: _propTypes.default.string,
  iconAlignment: _propTypes.default.string
};
var _default = Icon;
exports.default = _default;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = __webpack_require__(12);

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(5);

var _Background = _interopRequireDefault(__webpack_require__(6));

var _ContentWrapper = _interopRequireDefault(__webpack_require__(17));

var _hover = __webpack_require__(14);

var _classes = __webpack_require__(2);

var _configuration = __webpack_require__(27);

var _analytics = __webpack_require__(7);

var _text = __webpack_require__(32);

__webpack_require__(43);

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var setWrapperClassNames = function setWrapperClassNames(enableClickable, isHovered, imageLocation) {
  for (var _len = arguments.length, classes = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    classes[_key - 3] = arguments[_key];
  }

  var classNames = ['cta', 'd-flex', 'position-relative'].concat(classes);

  if (imageLocation === 'background-right' || imageLocation === 'background-left') {
    classNames.push('flex-row');

    if (imageLocation === 'background-right') {
      classNames.push('flex-row-reverse');
    }
  } else {
    classNames.push('flex-column');
  }

  if (enableClickable) {
    classNames.push('pointer', 'text-no-decoration');

    if (isHovered) {
      classNames.push('hover');
    }
  }

  return _classes.setClassNames.apply(_this, classNames);
};

var setStyles = function setStyles() {
  var widgetHeight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var styles = {};

  if (widgetHeight) {
    styles.height = widgetHeight;
  }

  return styles;
};

var handleClick = function handleClick(event, url, enableOpenNewWindow, elementCTA, windowId, isClickableModal) {
  event.preventDefault();
  (0, _analytics.triggerTrackingEvent)('ws-content-cta Call to action', elementCTA, "Navigated to ".concat(url), windowId);

  if (!isClickableModal) {
    if (enableOpenNewWindow) {
      window.open(url);
    } else {
      window.location.href = url;
    }
  }
};

var WidgetContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetContainer, _React$Component);

  function WidgetContainer() {
    _classCallCheck(this, WidgetContainer);

    return _possibleConstructorReturn(this, _getPrototypeOf(WidgetContainer).apply(this, arguments));
  }

  _createClass(WidgetContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(_common.Common, {
        render: function render(_ref) {
          var prefs = _ref.prefs,
              labels = _ref.labels,
              sitemap = _ref.sitemap;
          var displayStyle = prefs.displayStyle;
          var _this2$props$widgetIn = _this2.props.widgetInfo,
              deviceType = _this2$props$widgetIn.deviceType,
              windowId = _this2$props$widgetIn.windowId;
          var isHovered = _this2.props.hover.isHovered;
          var widgetConfiguration = (0, _configuration.setWidgetConfiguration)(deviceType, isHovered, displayStyle, prefs, sitemap);
          var widgetHeight = widgetConfiguration.widgetHeight,
              dialogWindowWidth = widgetConfiguration.dialogWindowWidth,
              enableDialogWindow = widgetConfiguration.enableDialogWindow,
              enableOpenNewWindow = widgetConfiguration.enableOpenNewWindow,
              enableClickable = widgetConfiguration.enableClickable,
              url = widgetConfiguration.url,
              showButton = widgetConfiguration.showButton,
              imageLocation = widgetConfiguration.imageLocation,
              headingLabel = widgetConfiguration.headingLabel,
              contentLabel = widgetConfiguration.contentLabel,
              buttonLabel = widgetConfiguration.buttonLabel,
              accessibleDescription = widgetConfiguration.accessibleDescription,
              dialogWindowTitleLabel = widgetConfiguration.dialogWindowTitleLabel,
              widgetBackgroundColor = widgetConfiguration.widgetBackgroundColor,
              widgetTransitionProperty = widgetConfiguration.widgetTransitionProperty,
              widgetTransitionTimingFunction = widgetConfiguration.widgetTransitionTimingFunction,
              widgetTransitionDuration = widgetConfiguration.widgetTransitionDuration,
              backgroundWrapperWidth = widgetConfiguration.backgroundWrapperWidth;
          var isClickable = enableClickable && url !== '';
          var isAnchorElement = isClickable && !showButton;
          var isClickableDivElement = isClickable && !isAnchorElement;
          var isClickableModal = enableDialogWindow && (isClickableDivElement || isAnchorElement);
          var WidgetElement = isAnchorElement ? 'a' : 'div';
          var target = enableOpenNewWindow && !enableDialogWindow ? '_blank' : '';
          var headingText = headingLabel && labels.getHTML(headingLabel);
          var dialogWindowTitleText = labels.get(dialogWindowTitleLabel);
          var ariaLabel = labels.get(accessibleDescription);
          return _react.default.createElement(WidgetElement, {
            className: setWrapperClassNames(enableClickable, isHovered, imageLocation, widgetBackgroundColor, widgetTransitionProperty, widgetTransitionTimingFunction, widgetTransitionDuration, isClickableModal ? 'dialog' : ''),
            style: setStyles(widgetHeight),
            href: isAnchorElement ? url : null,
            "aria-label": ariaLabel || null,
            "aria-labelledby": !ariaLabel ? "".concat(windowId, "-heading ").concat(windowId, "-button") : null,
            role: isClickableDivElement ? 'button' : null,
            "data-href": isClickableModal ? url : null,
            "data-modal": isClickableModal ? 'true' : null,
            "data-title": isClickableModal && dialogWindowTitleText ? dialogWindowTitleText : null,
            "data-width": isClickableModal && dialogWindowWidth ? dialogWindowWidth : null,
            target: isAnchorElement && target ? target : null,
            onClick: isClickable ? function (event) {
              return handleClick(event, url, enableOpenNewWindow, headingText, windowId, isClickableModal);
            } : null,
            onMouseEnter: function onMouseEnter() {
              return enableClickable && _this2.props.setHover(true);
            },
            onMouseLeave: function onMouseLeave() {
              return enableClickable && _this2.props.setHover(false);
            }
          }, imageLocation !== 'foreground' && _react.default.createElement("div", {
            className: backgroundWrapperWidth,
            style: {
              overflow: 'hidden'
            }
          }, _react.default.createElement(_Background.default, widgetConfiguration)), _react.default.createElement(_ContentWrapper.default, {
            widgetConfiguration: widgetConfiguration,
            windowId: windowId,
            isClickableDivElement: isClickableDivElement,
            imageLocation: imageLocation,
            headingText: headingText,
            contentText: contentLabel && (0, _text.getHtmlWithDLData)(labels.get(contentLabel)),
            buttonText: buttonLabel && labels.getHTML(buttonLabel),
            dialogWindowTitleText: dialogWindowTitleText,
            target: target
          }));
        }
      });
    }
  }]);

  return WidgetContainer;
}(_react.default.Component);

WidgetContainer.propTypes = {
  hover: _propTypes.default.shape({
    isHovered: _propTypes.default.bool.isRequired
  }).isRequired,
  setHover: _propTypes.default.func.isRequired,
  widgetInfo: _propTypes.default.shape({
    deviceType: _propTypes.default.string.isRequired,
    windowId: _propTypes.default.string.isRequired
  }).isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hover: state.hover,
    widgetInfo: state.widgetInfo
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setHover: function setHover(isHovered) {
      dispatch((0, _hover.setHover)(isHovered));
    }
  };
};

var Widget = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WidgetContainer);
var _default = Widget;
exports.default = _default;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DDC_ICON_PREFIX = void 0;
var DDC_ICON_PREFIX = 'ddc-icon-';
exports.DDC_ICON_PREFIX = DDC_ICON_PREFIX;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [];
exports.default = _default;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hover;

var _types = __webpack_require__(3);

function hover() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_HOVER:
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hover = _interopRequireDefault(__webpack_require__(23));

var _widgetInfo = _interopRequireDefault(__webpack_require__(25));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var root = {
  hover: _hover.default,
  widgetInfo: _widgetInfo.default
};
var _default = root;
exports.default = _default;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = widgetInfo;

var _types = __webpack_require__(3);

function widgetInfo() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (!action.error && action.payload) {
    switch (action.type) {
      case _types.SET_WIDGET_INFO:
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setBackgroundStyles = exports.setBackgroundClassNames = void 0;

var _classes = __webpack_require__(2);

var _images = __webpack_require__(9);

var _this = void 0;

/**
 * Sets the background classes based on configuration parameters
 * Returns string with joined classes or null if no classes are defined
 * @param {string} imageLocation - A string value for image location (i.e. 'foreground' or 'background')
 * @param {boolean} foregroundImageCircle - A boolean value for displaying foreground image as a circle
 * @param {string} foregroundImageMargin - A string value for image margin class
 * @param {string} foregroundImagePadding - A string value for image padding class
 * @param {string} foregroundImageAlignment - A string value for image alignment class
 * @param {string} backgroundColor - A string value for background color class
 */
var setBackgroundClassNames = function setBackgroundClassNames(imageLocation, foregroundImageCircle, foregroundImageMargin, foregroundImagePadding, foregroundImageAlignment, backgroundColor) {
  for (var _len = arguments.length, classes = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
    classes[_key - 6] = arguments[_key];
  }

  var classNames = classes.concat();

  if (imageLocation === 'foreground') {
    classNames.push('cta-foreground');
    classNames.push(foregroundImageMargin);
    classNames.push(foregroundImagePadding);
    classNames.push(foregroundImageAlignment);

    if (foregroundImageCircle) {
      classNames.push('img-circle');
    }
  } else {
    classNames.push(backgroundColor);
    classNames.push('cta-background', 'h-100', 'w-100');

    if (imageLocation === 'background') {
      classNames.push('position-absolute');
    }
  }

  return _classes.setClassNames.apply(_this, classNames);
};
/**
 * Sets the background styles based on configuration parameters
 * Returns an object with all styles defined
 * @param {boolean} showImage - A boolean value for displaying image
 * @param {string} imageLocation - A string value for image location (i.e. 'foreground' or 'background')
 * @param {string} imageUrl - A string value for image URL
 * @param {string} imagePosition - A string value for background position
 * @param {string} imageSize - A string value for background size
 * @param {string} backgroundGradient - A string value for background gradient
 * @param {string} backgroundRepeat - A string value for background repeat
 * @param {number} foregroundImageHeight - A number value for height
 * @param {number} foregroundImageWidth - A number value for width
 * @param {boolean} hasResponsiveImage - A boolean value for whether image is responsive
 * @param {string} backgroundImage - A string value for background image src
 */


exports.setBackgroundClassNames = setBackgroundClassNames;

var setBackgroundStyles = function setBackgroundStyles(showImage, imageLocation, imageUrl, imagePosition, imageSize, backgroundGradient, backgroundRepeat, foregroundImageHeight, foregroundImageWidth, hasResponsiveImage, backgroundImage) {
  var styles = {};
  var backgroundImageUrl = backgroundImage;

  if (showImage) {
    if (!hasResponsiveImage) {
      backgroundImageUrl = (0, _images.setImageUrl)(imageUrl, foregroundImageHeight, foregroundImageWidth, imageLocation);
    }

    if (imagePosition) {
      styles.backgroundPosition = imagePosition;
    }

    if (imageSize) {
      styles.backgroundSize = imageSize;
    }

    if (imageLocation === 'foreground') {
      styles.flex = 'none';

      if (foregroundImageHeight) {
        styles.height = "".concat(foregroundImageHeight, "px");
      }

      if (foregroundImageWidth) {
        styles.width = "".concat(foregroundImageWidth, "px");
      }

      if (imageUrl) {
        styles.backgroundImage = "url('".concat(backgroundImageUrl, "')");
        styles.backgroundRepeat = 'no-repeat';
      }
    } else {
      if (backgroundGradient && imageUrl) {
        styles.backgroundImage = "".concat(backgroundGradient, ", url('").concat(backgroundImageUrl, "')");
      } else if (backgroundGradient) {
        styles.backgroundImage = backgroundGradient;
      } else if (imageUrl) {
        styles.backgroundImage = "url('".concat(backgroundImageUrl, "')");
      }

      if (backgroundRepeat) {
        styles.backgroundRepeat = backgroundRepeat;
      }
    }
  } else if (backgroundGradient) {
    styles.backgroundImage = backgroundGradient;
  }

  return styles;
};

exports.setBackgroundStyles = setBackgroundStyles;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setWidgetConfiguration = void 0;

var _format = __webpack_require__(29);

var _images = __webpack_require__(8);

var _hover = __webpack_require__(30);

var _links = __webpack_require__(31);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Sets the configuration object for the widget
 * Returns a new object based on widget display logic conditions
 * @param {string} deviceType - The request data device ('MOBILE', 'DESKTOP')
 * @param {boolean} isHovered - The hover event of the entire app
 * @param {string} displayStyle - The display style of the widget
 * @param {object} prefs - The preferences object
 * @param {object} sitemap - The sitemap object
 */
var setWidgetConfiguration = function setWidgetConfiguration(deviceType, isHovered, displayStyle) {
  var prefs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var sitemap = arguments.length > 4 ? arguments[4] : undefined;
  var trimmedPrefs = (0, _format.trimObj)(prefs);

  var formattedConfiguration = _objectSpread({}, trimmedPrefs, {
    enableClickable: (0, _format.toBoolean)(trimmedPrefs.enableClickable),
    enableOpenNewWindow: (0, _format.toBoolean)(trimmedPrefs.enableOpenNewWindow),
    enableDialogWindow: (0, _format.toBoolean)(trimmedPrefs.enableDialogWindow),
    showIcon: (0, _format.toBoolean)(trimmedPrefs.showIcon),
    showImage: (0, _format.toBoolean)(trimmedPrefs.showImage),
    showHeading: (0, _format.toBoolean)(trimmedPrefs.showHeading),
    showContent: (0, _format.toBoolean)(trimmedPrefs.showContent),
    showButton: (0, _format.toBoolean)(trimmedPrefs.showButton),
    foregroundImageCircle: (0, _format.toBoolean)(trimmedPrefs.foregroundImageCircle),
    foregroundImageHeight: (0, _format.toInt)(trimmedPrefs.foregroundImageHeight),
    foregroundImageWidth: (0, _format.toInt)(trimmedPrefs.foregroundImageWidth),
    iconName: (0, _format.toIcon)(trimmedPrefs.iconName)
  });

  var defaultConfiguration = _objectSpread({}, formattedConfiguration, {
    enableContentOverflowHidden: true,
    url: (0, _links.setUrl)(sitemap, formattedConfiguration.url),
    backgroundWrapperWidth: 'w-100',
    contentWrapperWidth: 'w-100',
    headingElement: formattedConfiguration.headingElement || 'h2',
    headingClasses: '',
    buttonAlignment: formattedConfiguration.widgetAlignment ? null : 'align-self-start',
    foregroundImageHeight: (0, _images.setImageDimension)('height', deviceType, formattedConfiguration.foregroundImageHeight, formattedConfiguration.foregroundImageWidth, formattedConfiguration.foregroundImageCircle),
    foregroundImageWidth: (0, _images.setImageDimension)('width', deviceType, formattedConfiguration.foregroundImageHeight, formattedConfiguration.foregroundImageWidth, formattedConfiguration.foregroundImageCircle),
    widgetTransitionProperty: 'transition-property-background-color transition-property-text-color',
    widgetTransitionTimingFunction: 'transition-timing-function-standard',
    widgetTransitionDuration: 'transition-duration-lg',
    backgroundTransitionProperty: 'transition-property-background-color',
    backgroundTransitionTimingFunction: 'transition-timing-function-standard',
    backgroundTransitionDuration: 'transition-duration-lg',
    headingTransitionProperty: '',
    headingTransitionTimingFunction: '',
    headingTransitionDuration: '',
    contentWrapperTransitionProperty: '',
    contentWrapperTransitionTimingFunction: '',
    contentWrapperTransitionDuration: '',
    buttonTransitionProperty: '',
    buttonTransitionTimingFunction: '',
    buttonTransitionDuration: '',
    contentTransitionProperty: '',
    contentTransitionTimingFunction: '',
    contentTransitionDuration: ''
  });

  var hoverConfiguration = {
    widgetBackgroundColor: (0, _hover.setHoverValue)(isHovered, defaultConfiguration.widgetBackgroundColorHover, defaultConfiguration.widgetBackgroundColor),
    textColor: (0, _hover.setHoverValue)(isHovered, defaultConfiguration.textColorHover, defaultConfiguration.textColor),
    backgroundColor: (0, _hover.setHoverValue)(isHovered, defaultConfiguration.backgroundColorHover, defaultConfiguration.backgroundColor),
    backgroundGradient: (0, _hover.setHoverValue)(isHovered, defaultConfiguration.backgroundGradientHover, defaultConfiguration.backgroundGradient)
  };
  var displayStyleConfiguration = {
    widgetAlignment: 'align-items-center',
    widgetJustify: '',
    widgetMargin: '',
    widgetPadding: 'p-5',
    enableClickable: false,
    showIcon: false,
    showImage: true,
    showHeading: true,
    showContent: true,
    showButton: true,
    textAlignment: 'text-center',
    imageLocation: 'background',
    backgroundColor: '',
    backgroundColorHover: '',
    backgroundGradient: '',
    backgroundGradientHover: '',
    iconMargin: '',
    iconPadding: '',
    iconAlignment: '',
    foregroundImageMargin: '',
    foregroundImagePadding: '',
    foregroundImageAlignment: '',
    foregroundImageCircle: false,
    headingPadding: '',
    headingAlignment: '',
    headingMargin: 'mt-0',
    contentMargin: '',
    contentPadding: '',
    contentAlignment: '',
    buttonAlignment: 'align-self-center',
    buttonMargin: ''
  };

  switch (displayStyle) {
    case 'icon-heading-content-cta-centered':
      return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, {
        widgetJustify: 'justify-content-center',
        imageUrl: '',
        showIcon: true,
        iconMargin: 'm-0',
        headingMargin: 'mt-6 mx-0 mb-4',
        contentMargin: 'mt-0 mx-0 mb-4',
        buttonMargin: 'm-0'
      });

    case 'image-heading-content-cta-centered':
      return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, {
        widgetJustify: 'justify-content-center',
        imageLocation: 'foreground',
        foregroundImageCircle: true,
        foregroundImageHeight: (0, _images.setImageDimension)('height', deviceType, formattedConfiguration.foregroundImageHeight, formattedConfiguration.foregroundImageWidth, true),
        foregroundImageWidth: (0, _images.setImageDimension)('width', deviceType, formattedConfiguration.foregroundImageHeight, formattedConfiguration.foregroundImageWidth, true),
        foregroundImageMargin: 'mt-0 mx-0 mb-5',
        headingMargin: 'mt-0 mx-0 mb-4',
        contentMargin: 'mt-0 mx-0 mb-4',
        buttonMargin: 'm-0'
      });

    case 'background-image-zoom-heading':
      {
        var backgroundTransitionConfiguration = deviceType === 'DESKTOP' ? {
          backgroundTransitionProperty: "transition-property-transform scale-".concat(isHovered ? '110' : '100'),
          backgroundTransitionTimingFunction: 'transition-timing-function-standard',
          backgroundTransitionDuration: 'transition-duration-xl'
        } : null;
        return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, backgroundTransitionConfiguration, {
          enableClickable: true,
          showContent: false,
          showButton: false,
          headingMargin: 'mt-auto mb-0',
          headingColor: 'text-white',
          backgroundColor: 'bg-black',
          backgroundGradient: 'linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,.6) 100%)'
        });
      }

    case 'background-image-zoom-icon-heading':
      {
        var _backgroundTransitionConfiguration = deviceType === 'DESKTOP' ? {
          backgroundTransitionProperty: "transition-property-transform scale-".concat(isHovered ? '110' : '100'),
          backgroundTransitionTimingFunction: 'transition-timing-function-standard',
          backgroundTransitionDuration: 'transition-duration-xl'
        } : null;

        return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, _backgroundTransitionConfiguration, {
          widgetJustify: 'justify-content-center',
          enableClickable: true,
          showContent: false,
          showIcon: true,
          showButton: false,
          iconSize: defaultConfiguration.iconSize || 'icon-size-7',
          iconColor: defaultConfiguration.iconColor || 'text-primary-300',
          headingMargin: 'mt-3 mx-0 mb-0',
          headingColor: defaultConfiguration.headingColor || 'text-white',
          backgroundColor: defaultConfiguration.backgroundColor || 'bg-black',
          backgroundGradient: defaultConfiguration.backgroundGradient || 'linear-gradient(rgba(0,0,0,.6) 0%, rgba(0,0,0,.6) 100%)'
        });
      }

    case 'heading-left-image-right-zoom':
      {
        var _backgroundTransitionConfiguration2 = deviceType === 'DESKTOP' ? {
          backgroundTransitionProperty: "transition-property-transform scale-".concat(isHovered ? '105' : '100'),
          backgroundTransitionTimingFunction: 'transition-timing-function-standard',
          backgroundTransitionDuration: 'transition-duration-xl'
        } : null;

        return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, _backgroundTransitionConfiguration2, {
          widgetJustify: 'justify-content-center',
          widgetBackgroundColor: isHovered ? defaultConfiguration.widgetBackgroundColorHover || 'bg-light' : defaultConfiguration.widgetBackgroundColor || '',
          enableClickable: true,
          showContent: false,
          showButton: false,
          backgroundWrapperWidth: 'w-50',
          contentWrapperWidth: 'w-50',
          imageLocation: 'background-left',
          textColor: isHovered ? defaultConfiguration.textColorHover || 'text-primary' : defaultConfiguration.textColor || 'text-body',
          headingClasses: 'centered-border-bottom-sm',
          headingMargin: 'm-0',
          headingTransitionProperty: "transition-property-after-transform scale-after-".concat(isHovered ? '150-100' : '100'),
          headingTransitionTimingFunction: 'transition-timing-function-after-standard',
          headingTransitionDuration: 'transition-duration-after-md'
        });
      }

    case 'image-left-zoom-heading-right':
      {
        var _backgroundTransitionConfiguration3 = deviceType === 'DESKTOP' ? {
          backgroundTransitionProperty: "transition-property-transform scale-".concat(isHovered ? '105' : '100'),
          backgroundTransitionTimingFunction: 'transition-timing-function-standard',
          backgroundTransitionDuration: 'transition-duration-xl'
        } : null;

        return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, _backgroundTransitionConfiguration3, {
          widgetJustify: 'justify-content-center',
          widgetBackgroundColor: isHovered ? defaultConfiguration.widgetBackgroundColorHover || 'bg-light' : defaultConfiguration.widgetBackgroundColor || '',
          enableClickable: true,
          showContent: false,
          showButton: false,
          backgroundWrapperWidth: 'w-50',
          contentWrapperWidth: 'w-50',
          imageLocation: 'background-right',
          textColor: isHovered ? defaultConfiguration.textColorHover || 'text-primary' : defaultConfiguration.textColor || 'text-body',
          headingClasses: 'centered-border-bottom-sm',
          headingMargin: 'm-0',
          headingTransitionProperty: "transition-property-after-transform scale-after-".concat(isHovered ? '150-100' : '100'),
          headingTransitionTimingFunction: 'transition-timing-function-after-standard',
          headingTransitionDuration: 'transition-duration-after-md'
        });
      }

    case 'background-zoom-hover-rollup':
      {
        var _backgroundTransitionConfiguration4 = deviceType === 'DESKTOP' ? {
          backgroundTransitionProperty: "transition-property-transform scale-".concat(isHovered ? '110' : '100'),
          backgroundTransitionTimingFunction: 'transition-timing-function-standard',
          backgroundTransitionDuration: 'transition-duration-xl'
        } : null;

        var rollupConfiguration;

        if (deviceType === 'DESKTOP') {
          rollupConfiguration = {
            contentWrapperTransitionProperty: isHovered ? 'translate-up-10' : 'translate-down-0',
            buttonTransitionProperty: isHovered ? 'opacity-100' : 'opacity-0',
            widgetPadding: 'p-0',
            headingColor: 'text-white',
            headingMargin: 'm-2',
            buttonSize: 'btn-xsmall',
            buttonMargin: isHovered ? 'mt-4' : 'mt-3'
          };
        } else {
          rollupConfiguration = {
            contentTransitionProperty: 'opacity-0',
            buttonTransitionProperty: 'opacity-100',
            showContent: false,
            widgetPadding: 'p-6',
            headingColor: 'text-white',
            headingMargin: 'm-4',
            buttonSize: 'btn-small'
          };
        }

        return _objectSpread({}, defaultConfiguration, displayStyleConfiguration, _backgroundTransitionConfiguration4, rollupConfiguration, {
          contentWrapperTransitionTimingFunction: 'transition-timing-function-standard',
          contentWrapperTransitionDuration: 'transition-duration-xl',
          buttonTransitionTimingFunction: 'transition-timing-function-standard',
          buttonTransitionDuration: 'transition-duration-xl',
          enableClickable: true,
          showButton: true,
          buttonStyle: 'btn-default btn-inverse',
          contentColor: 'text-white',
          contentMargin: 'm-0',
          widgetJustify: 'justify-content-end',
          contentSize: 'h4',
          backgroundColor: 'bg-black',
          backgroundGradient: 'linear-gradient(rgba(0,0,0,0) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,.6) 100%)'
        });
      }

    default:
      return _objectSpread({}, defaultConfiguration, hoverConfiguration);
  }
};

exports.setWidgetConfiguration = setWidgetConfiguration;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setParamSeparator = void 0;

/**
 * Sets the correct URL param separator based on existence of `?`
 * @param {string} url - A string value to be checked for existing param separators
 */
var setParamSeparator = function setParamSeparator(url) {
  return url && url.includes('?') ? '&' : '?';
};

exports.setParamSeparator = setParamSeparator;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toIcon = exports.toInt = exports.toBoolean = exports.trimObj = void 0;

var _globalConstants = __webpack_require__(21);

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Trims the values in a flat object property
 * Returns an empty object if the argument is an empty object
 * @param {object} obj - A flat 'key: value' object
 */
var trimObj = function trimObj() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== null && _typeof(obj[key]) === 'object') {
      throw new Error("The property '".concat(key, "' is of type 'Object' that cannot be trimmed"));
    }

    acc[key] = obj[key].trim();
    return acc;
  }, {});
};
/**
 * Converts a string to a boolean value
 * Returns a boolean value with a default value of false
 * @param {string} value - A string value of "true" or "false"
 */


exports.trimObj = trimObj;

var toBoolean = function toBoolean() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return value.toLowerCase().trim() === 'true';
};
/**
 * Converts a string to an integer value
 * Returns an integer
 * @param {string} value - A string value to be converted to an integer
 */


exports.toBoolean = toBoolean;

var toInt = function toInt() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return parseInt(value, 10) || 0;
};
/**
 * Converts a string to a `ddc-icon-` prefaced string value
 * Returns a string
 * @param {string} iconName - A string value to be converted to a DDC icon class
 */


exports.toInt = toInt;

var toIcon = function toIcon() {
  var iconName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return iconName && (iconName.indexOf(_globalConstants.DDC_ICON_PREFIX) === 0 ? iconName : "".concat(_globalConstants.DDC_ICON_PREFIX).concat(iconName));
};

exports.toIcon = toIcon;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setHoverValue = void 0;

/**
 * Sets a value based on boolean param value
 * Returns a string value if hover state and hover value is present or
 * else it will return an empty string
 * @param {boolean} isHovered - A boolean value dictating returned value
 * @param {string} hoverValue - A string value for hover display state
 * @param {string} defaultValue - A string value for default display state
 */
var setHoverValue = function setHoverValue() {
  var isHovered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var hoverValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return isHovered && hoverValue ? hoverValue : defaultValue;
};

exports.setHoverValue = setHoverValue;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUrl = exports.determineUrlType = exports.isStringAbsoluteUrl = exports.isStringAlias = void 0;

/**
 * Checks if the string is valid sitemap entry alias eg: uppercase and underscores
 * @param {string} str - A string that is checked against
 */
var isStringAlias = function isStringAlias() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var r = new RegExp('^[A-Z0-9_]+$', 'g');
  return r.test(str);
};
/**
 * Determines if the string passed in is an absolute url
 * @param {string} str - A string that is checked against
 */


exports.isStringAlias = isStringAlias;

var isStringAbsoluteUrl = function isStringAbsoluteUrl() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var r = new RegExp('^(?:[a-z]+:)?//', 'i');
  return r.test(str);
};
/**
 * Determines the url type passed in either as ALIAS, ABSOLUTE or RELATIVE
 * @param {string} url - A string value with a URL string or page alias
 */


exports.isStringAbsoluteUrl = isStringAbsoluteUrl;

var determineUrlType = function determineUrlType() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (isStringAlias(url)) {
    return 'ALIAS';
  } else if (isStringAbsoluteUrl(url)) {
    return 'ABSOLUTE';
  } else {
    return 'RELATIVE';
  }
};
/**
 * Sets the URL string based on sitemap request
 * Returns a string value after requesting a path from the sitemap service
 * @param {object} sitemap - An object containing helper functions for sitemap entries
 * @param {string} url - A string value with a URL string or page alias
 */


exports.determineUrlType = determineUrlType;

var setUrl = function setUrl(sitemap) {
  var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  switch (determineUrlType(url)) {
    case 'ALIAS':
      return sitemap.has(url) ? sitemap.get(url) : '/404.htm';

    default:
      return url || '/404.htm';
  }
};

exports.setUrl = setUrl;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHtmlWithDLData = exports.parseTransformedText = exports.dataLayerReplacer = exports.patternReplacer = void 0;

var _htmlReactParser = _interopRequireDefault(__webpack_require__(47));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Get data from datalayer dealership with a given key
 * Returns a string with default value of empty string
 * @param {string} key - A string value used for search for a value in dealership object
 */
var getDealershipData = function getDealershipData(key) {
  var _global = global,
      window = _global.window;

  if (typeof window !== 'undefined' && window.DDC && window.DDC.dataLayer && window.DDC.dataLayer.dealership) {
    return window.DDC.dataLayer.dealership[key];
  }

  return '';
};

var patternKeyMap = {
  '{{city}}': function city() {
    return getDealershipData('city');
  },
  '{{dealer}}': function dealer() {
    return getDealershipData('dealershipName');
  }
};
/**
 * Takes the mapValue and execute it if is a function
 * Returns a string with default value of the str param
 * @param {string|function} mapValue - a function which return an string or an string, to be used as return value
 * @param {string} str - string value to be used if there is not mapValue
 */

var getReplacement = function getReplacement(mapValue, str) {
  if (mapValue) {
    if (typeof mapValue === 'function') {
      return mapValue();
    } else {
      return mapValue;
    }
  }

  return str;
};
/**
 * Get a text and apply a regex to find a pattern and get a the replacement from a key value object
 * Returns a string with the new text after being modified
 * @param {RegExp} regex - a RegExp to be used as a pattern finder
 * @param {Object} replacerMap - an Object which contain the pattern as the key and the value is the way to get the replacement
 * @param {string} text - an string to modify
 */


var patternReplacer = function patternReplacer(regex, replacerMap, text) {
  return text.split(regex).map(function (str) {
    return getReplacement(replacerMap[str], str);
  }).join('');
};
/**
 * Find "{{}}" pattern in a text and replace it using the patternKeyMap dictionary
 * Returns a string with the new text after being modified
 * @param {string} text - an string to modify
 */


exports.patternReplacer = patternReplacer;

var dataLayerReplacer = function dataLayerReplacer(text) {
  return patternReplacer(/({{[a-z_0-9]+}})/gi, patternKeyMap, text);
};
/**
 * Takes a text applies a function to transform it and then a function to parse it
 * Returns a value with the result of apply the functions to it
 * @param {function} parser - a function to parse the result of the transform function
 * @param {function} transformFn - a fuction to transform the text param
 * @param {string} text - an string to be transformed and parsed
 */


exports.dataLayerReplacer = dataLayerReplacer;

var parseTransformedText = function parseTransformedText(parser, transformFn, text) {
  return parser(transformFn(text));
};
/**
 * Takes a text applies the datalayerReplacer function and then Parse it as html
 * Returns a value with the result of apply the Parser
 * @param {string} text - an string to be transformed and parsed
 */


exports.parseTransformedText = parseTransformedText;

var getHtmlWithDLData = function getHtmlWithDLData(text) {
  return parseTransformedText(_htmlReactParser.default, dataLayerReplacer, text);
};

exports.getHtmlWithDLData = getHtmlWithDLData;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackGoogleAnalyticsEvent = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Triggers a tracking event using data from widget
 * Returns a tracking object within a triggered `trackEvent` event
 * Refer to https://fuel.coxautoinc.com/docs/DOC-144882 for usage and defaults
 * @param {object} eventData - An object containing event data
 */
var trackGoogleAnalyticsEvent = function trackGoogleAnalyticsEvent(eventData, window) {
  var trackingObject = _typeof(window) === 'object' ? window.jQuery(document) : {};
  var defaultClickEvent = {
    event: 'widgetUserEvent',
    action: 'clicked',
    widgetState: 'default',
    fieldValue: undefined,
    formId: undefined,
    formEventId: undefined,
    value: undefined,
    widgetName: 'ws-content-cta'
  };

  if (Object.keys(trackingObject).length > 0) {
    return trackingObject.trigger('trackEvent', _objectSpread({}, defaultClickEvent, eventData));
  }

  return null;
};

exports.trackGoogleAnalyticsEvent = trackGoogleAnalyticsEvent;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Collapse = function Collapse(props) {
  var id = props.id,
      children = props.children,
      toggleCollapse = props.toggleCollapse;

  if (toggleCollapse) {
    return _react.default.createElement("div", {
      id: "".concat(id, "-collapse"),
      className: "collapse collapse-content"
    }, children);
  }

  return children;
};

Collapse.propTypes = {
  id: _propTypes.default.string.isRequired,
  children: _propTypes.default.element.isRequired,
  toggleCollapse: _propTypes.default.bool
};
Collapse.defaultProps = {
  toggleCollapse: false
};
var _default = Collapse;
exports.default = _default;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _common = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// eslint-disable-line import/no-unresolved
var WidgetHeading =
/*#__PURE__*/
function (_React$Component) {
  _inherits(WidgetHeading, _React$Component);

  function WidgetHeading(props) {
    var _this;

    _classCallCheck(this, WidgetHeading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetHeading).call(this, props));
    _this.renderDelegate = _this.renderDelegate.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(WidgetHeading, [{
    key: "renderDelegate",
    value: function renderDelegate(_ref) {
      var labels = _ref.labels;
      var _this$props = this.props,
          HeadingTag = _this$props.HeadingTag,
          headingText = _this$props.headingText,
          widgetId = _this$props.widgetId,
          toggleCollapse = _this$props.toggleCollapse,
          showIcon = _this$props.showIcon,
          headingClasses = _this$props.headingClasses,
          iconClasses = _this$props.iconClasses;

      var allIconClasses = _toConsumableArray(iconClasses);

      var collapseAttributes = {};

      if (toggleCollapse) {
        var iconExpand = 'ddc-icon-expand';
        allIconClasses.push(iconExpand);
        allIconClasses.push('icon-style-collapse');
        collapseAttributes = {
          role: 'button',
          'data-toggle': 'collapse',
          'data-target': "#".concat(widgetId, "-collapse"),
          'data-expand-icon-class': "".concat(iconExpand),
          'data-collapse-icon-class': 'ddc-icon-collapse',
          'aria-expanded': 'false',
          'aria-controls': "".concat(widgetId, "-collapse")
        };
      }

      return _react.default.createElement(HeadingTag, _extends({
        className: headingClasses.join(' ')
      }, collapseAttributes), showIcon && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("i", {
        className: allIconClasses.join(' ')
      }), ' '), labels.getHTML(headingText));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.headingText || this.props.headingText.toUpperCase() === 'FALSE') {
        return null;
      } else {
        return _react.default.createElement(_common.Common, {
          render: this.renderDelegate
        });
      }
    }
  }]);

  return WidgetHeading;
}(_react.default.Component);

WidgetHeading.propTypes = {
  HeadingTag: _propTypes.default.string,
  headingText: _propTypes.default.string,
  widgetId: _propTypes.default.string.isRequired,
  toggleCollapse: _propTypes.default.bool.isRequired,
  showIcon: _propTypes.default.bool.isRequired,
  headingClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  iconClasses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
};
WidgetHeading.defaultProps = {
  HeadingTag: 'h3',
  headingText: ''
};
var _default = WidgetHeading;
exports.default = _default;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _root = __webpack_require__(51);

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactRedux = __webpack_require__(12);

var _WidgetHeading = _interopRequireDefault(__webpack_require__(35));

var _Collapse = _interopRequireDefault(__webpack_require__(34));

var _Widget = _interopRequireDefault(__webpack_require__(20));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: The eslint-disable-line is needed because this file won't lint
// when it's in the ws-scripts repo because the file only exists in the
// widget. It's safe because the entire application won't work if the
// file wasn't really resolved. It would be really apparent quickly.
// eslint-disable-line import/no-unresolved
var getWidgetClasses = function getWidgetClasses(widgetClasses, widgetName, toggleCollapse) {
  var classes = ['ddc-content', widgetName];

  if (widgetClasses) {
    classes.push(widgetClasses);
  }

  if (toggleCollapse) {
    classes.push('collapse-container');
  }

  return classes;
};

var getIconClasses = function getIconClasses(prefs, showIcon, toggleCollapse) {
  var iconClasses = [];
  var widgetHeading = prefs.widgetHeading,
      headingIconClasses = prefs.headingIconClasses,
      headingIconSize = prefs.headingIconSize,
      headingIconStyle = prefs.headingIconStyle;

  if (widgetHeading && showIcon) {
    iconClasses.push('ddc-icon');

    if (!toggleCollapse) {
      iconClasses.push("ddc-icon-".concat(headingIconStyle));
    }

    if (headingIconSize) {
      iconClasses.push("ddc-icon-size-".concat(headingIconSize));
    }

    if (headingIconClasses) {
      iconClasses.push(headingIconClasses);
    }
  }

  return iconClasses;
};

var getHeadingClasses = function getHeadingClasses(prefs, deviceType, toggleCollapse) {
  var headingClasses = [];
  var headingSize = prefs.headingSize,
      headingStyles = prefs.headingStyles;
  headingClasses.push('widget-heading');

  if (deviceType === 'MOBILE') {
    headingClasses.push('ddc-heading');
  }

  if (headingSize) {
    headingClasses.push(headingSize);
  }

  if (headingStyles) {
    headingClasses.push("ddc-heading-".concat(headingStyles));
  }

  if (toggleCollapse) {
    headingClasses.push('collapse-heading');
  }

  return headingClasses;
};

var WidgetWrapper = function WidgetWrapper(_ref) {
  var outputWrapperDiv = _ref.outputWrapperDiv,
      store = _ref.store,
      widgetId = _ref.widgetId,
      widgetName = _ref.widgetName;
  var state = store.getState();
  var prefs = state.prefs || {};
  var toggleCollapse = prefs.widgetHeading && prefs.toggleCollapse === 'true' || false;
  var showIcon = prefs.headingIconStyle ? true : toggleCollapse;

  var wrapping = _react.default.createElement(_reactRedux.Provider, {
    store: store
  }, _react.default.createElement(_WidgetHeading.default, {
    HeadingTag: prefs.headingTag,
    headingText: prefs.widgetHeading,
    widgetId: widgetId,
    toggleCollapse: toggleCollapse,
    showIcon: showIcon,
    headingClasses: getHeadingClasses(prefs, state.requestData.deviceType, toggleCollapse),
    iconClasses: getIconClasses(prefs, showIcon, toggleCollapse)
  }), _react.default.createElement(_Collapse.default, {
    id: widgetId,
    toggleCollapse: toggleCollapse
  }, _react.default.createElement(_Widget.default, null)));

  if (outputWrapperDiv) {
    if (!widgetName) {
      throw new Error('widgetName is required if outputWrapperDiv is true.');
    }

    return _react.default.createElement("div", {
      id: "".concat(widgetId, "-app-root"),
      className: getWidgetClasses(prefs.widgetClasses, widgetName, toggleCollapse).join(' '),
      "data-widget-name": widgetName,
      "data-widget-id": widgetId
    }, wrapping);
  }

  return wrapping;
};

WidgetWrapper.propTypes = {
  outputWrapperDiv: _propTypes.default.bool.isRequired,
  store: _propTypes.default.shape({
    getState: _propTypes.default.func.isRequired
  }).isRequired,
  widgetId: _propTypes.default.string.isRequired,
  widgetName: _propTypes.default.string
};
var _default = WidgetWrapper;
exports.default = _default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flags;

function flags() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_FEATURE_FLAGS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = labels;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function labels() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_LABELS':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefs;

function prefs() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_PREFS':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestData;

function requestData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload) {
    switch (action.type) {
      case 'WS_SCRIPTS_SET_REQUEST_DATA':
        return action.payload;
      // no default
    }
  }

  return state;
}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sitemap;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function sitemap() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!action.error && action.payload !== undefined) {
    switch (action.type) {
      case 'WS_SCRIPTS_ADD_SITEMAP':
        return _objectSpread({}, state, action.payload);
      // no default
    }
  }

  return state;
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;

var _redux = __webpack_require__(60);

var _reduxThunk = _interopRequireDefault(__webpack_require__(61));

var _reducers = _interopRequireDefault(__webpack_require__(24));

var _requestData = _interopRequireDefault(__webpack_require__(40));

var _prefs = _interopRequireDefault(__webpack_require__(39));

var _labels = _interopRequireDefault(__webpack_require__(38));

var _sitemap = _interopRequireDefault(__webpack_require__(41));

var _flags = _interopRequireDefault(__webpack_require__(37));

var _middleware = _interopRequireDefault(__webpack_require__(22));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-line import/no-unresolved
var providedReducers = {
  requestData: _requestData.default,
  prefs: _prefs.default,
  labels: _labels.default,
  sitemap: _sitemap.default,
  flags: _flags.default
};
var reducers = (0, _redux.combineReducers)(_objectSpread({}, _reducers.default, providedReducers));

var middleware = _toConsumableArray(_middleware.default).concat([_reduxThunk.default]);

var locationContains = function locationContains(search) {
  return window.location.toString().indexOf(search) !== -1;
};

var isBrowser = typeof window !== 'undefined';
var showReduxLoggerFromUrlParam = isBrowser && (locationContains('_mode=debug') || locationContains('wsScriptsUseReduxLogger=true'));

if (isBrowser && ("production" === 'development' || showReduxLoggerFromUrlParam)) {
  // Note: This must the be last middleware in the chain so that it logs actions
  // instead of thunks or Promises.
  // Use an actionTransformer to get the widget name into the output since
  // we have multiple stores running on one page. It may seem like using
  // titleFormatter makes more sense for this purpose, but doing so loses the
  // readability improvement coloring added in 2.10.0 of redux-logger. As of
  // 3.0.6, there is no way to get colors without using the default title formatter.
  // With the below action transformer and default title formatter, we get:
  // action ws-GENERIC-WIDGET-NAME - MIDDLEWARE_TEST @ 17:47:41.612 (in 0.30 ms)
  var actionTransformer = function actionTransformer(action) {
    return _objectSpread({}, action, {
      type: "ws-content-cta - ".concat(action.type)
    });
  };

  var _require = __webpack_require__(56),
      createLogger = _require.createLogger;

  var logger = createLogger({
    actionTransformer: actionTransformer,
    duration: true
  });
  middleware.push(logger);
}

var enhancer = _redux.applyMiddleware.apply(void 0, _toConsumableArray(middleware));

function createStore(initialState) {
  var store = (0, _redux.createStore)(reducers, initialState, enhancer);

  if (false) {
    module.hot.accept('../reducers', function () {
      var defaultReducers = require('../reducers').default; // eslint-disable-line import/no-unresolved


      store.replaceReducer((0, _redux.combineReducers)(_objectSpread({}, defaultReducers, providedReducers)));
    });
  }

  return store;
}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * SVG elements, unlike HTML elements, are case-sensitive.
 *
 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#SVG_elements_A_to_Z}
 */
var CASE_SENSITIVE_TAG_NAMES = [
    'animateMotion',
    'animateTransform',
    'clipPath',
    'feBlend',
    'feColorMatrix',
    'feComponentTransfer',
    'feComposite',
    'feConvolveMatrix',
    'feDiffuseLighting',
    'feDisplacementMap',
    'feDropShadow',
    'feFlood',
    'feFuncA',
    'feFuncB',
    'feFuncG',
    'feFuncR',
    'feGaussainBlur',
    'feImage',
    'feMerge',
    'feMergeNode',
    'feMorphology',
    'feOffset',
    'fePointLight',
    'feSpecularLighting',
    'feSpotLight',
    'feTile',
    'feTurbulence',
    'foreignObject',
    'linearGradient',
    'radialGradient',
    'textPath'
];

module.exports = {
    CASE_SENSITIVE_TAG_NAMES: CASE_SENSITIVE_TAG_NAMES
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */
var utilities = __webpack_require__(10);
var detectIE = utilities.isIE;

/**
 * Constants.
 */
var HTML_TAG_NAME = 'html';
var BODY_TAG_NAME = 'body';
var HEAD_TAG_NAME = 'head';
var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
var HEAD_REGEX = /<\/head>/i;
var BODY_REGEX = /<\/body>/i;
// http://www.w3.org/TR/html/syntax.html#void-elements
var VOID_ELEMENTS_REGEX = /<(area|base|br|col|embed|hr|img|input|keygen|link|menuitem|meta|param|source|track|wbr)(.*?)\/?>/gi;

// browser support
var isIE = detectIE();
var isIE9 = detectIE(9);

/**
 * DOMParser (performance: slow).
 *
 * https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */
var parseFromString;
if (typeof window.DOMParser === 'function') {
    var domParser = new window.DOMParser();
    // IE9 does not support 'text/html' MIME type
    // https://msdn.microsoft.com/en-us/library/ff975278(v=vs.85).aspx
    var MIME_TYPE = isIE9 ? 'text/xml' : 'text/html';

    /**
     * Creates an HTML document using `DOMParser.parseFromString`.
     *
     * @param  {String} html      - The HTML string.
     * @param  {String} [tagName] - The element to render the HTML (with 'body' as fallback).
     * @return {HTMLDocument}
     */
    parseFromString = function domStringParser(html, tagName) {
        if (tagName) {
            html = ['<', tagName, '>', html, '</', tagName, '>'].join('');
        }
        // because IE9 only supports MIME type 'text/xml', void elements need to be self-closed
        if (isIE9) {
            html = html.replace(VOID_ELEMENTS_REGEX, '<$1$2$3/>');
        }
        return domParser.parseFromString(html, MIME_TYPE);
    };
}

/**
 * DOMImplementation (performance: fair).
 *
 * https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */
var parseFromDocument;
if (typeof document.implementation === 'object') {
    // title parameter is required in IE
    // https://msdn.microsoft.com/en-us/library/ff975457(v=vs.85).aspx
    var doc = document.implementation.createHTMLDocument(isIE ? 'HTML_DOM_PARSER_TITLE' : undefined);

    /**
     * Use HTML document created by `document.implementation.createHTMLDocument`.
     *
     * @param  {String} html      - The HTML string.
     * @param  {String} [tagName] - The element to render the HTML (with 'body' as fallback).
     * @return {HTMLDocument}
     */
    parseFromDocument = function createHTMLDocument(html, tagName) {
        if (tagName) {
            doc.documentElement.getElementsByTagName(tagName)[0].innerHTML = html;
            return doc;
        }

        try {
            doc.documentElement.innerHTML = html;
            return doc;
        // fallback when certain elements in `documentElement` are read-only (IE9)
        } catch (err) {
            if (parseFromString) return parseFromString(html);
        }
    };
}

/**
 * Template (performance: fast).
 *
 * https://developer.mozilla.org/docs/Web/HTML/Element/template
 */
var parseFromTemplate;
var template = document.createElement('template');
if (template.content) {

    /**
     * Uses a template element (content fragment) to parse HTML.
     *
     * @param  {String} html - The HTML string.
     * @return {NodeList}
     */
    parseFromTemplate = function templateParser(html) {
        template.innerHTML = html;
        return template.content.childNodes;
    };
}

/** Fallback document parser. */
var parseWithFallback = parseFromDocument || parseFromString;

/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {String} html      - The HTML string.
 * @param  {String} [tagName] - The tag name.
 * @return {NodeList|Array}
 */
module.exports = function domparser(html) {
    // try to match first tag
    var tagName;
    var match = html.match(FIRST_TAG_REGEX);
    if (match && match[1]) {
        tagName = match[1].toLowerCase();
    }

    var doc;
    var element;
    var elements;

    switch (tagName) {
        case HTML_TAG_NAME:
            if (parseFromString) {
                doc = parseFromString(html);

                // the created document may come with filler head/body elements,
                // so ake sure to remove them if they don't actually exist
                if (!HEAD_REGEX.test(html)) {
                    element = doc.getElementsByTagName(HEAD_TAG_NAME)[0];
                    if (element) element.parentNode.removeChild(element);
                }
                if (!BODY_REGEX.test(html)) {
                    element = doc.getElementsByTagName(BODY_TAG_NAME)[0];
                    if (element) element.parentNode.removeChild(element);
                }

                return doc.getElementsByTagName(HTML_TAG_NAME);
            }
            break;

        case HEAD_TAG_NAME:
            if (parseWithFallback) {
                elements = parseWithFallback(html).getElementsByTagName(HEAD_TAG_NAME);

                // account for possibility of sibling
                if (BODY_REGEX.test(html)) {
                    return elements[0].parentNode.childNodes;
                }
                return elements;
            }
            break;

        case BODY_TAG_NAME:
            if (parseWithFallback) {
                elements = parseWithFallback(html).getElementsByTagName(BODY_TAG_NAME);

                // account for possibility of sibling (return both body and head)
                if (HEAD_REGEX.test(html)) {
                    return elements[0].parentNode.childNodes;
                }
                return elements;
            }
            break;

        // low-level tag or text
        default:
            if (parseFromTemplate) return parseFromTemplate(html);
            if (parseWithFallback) {
                return parseWithFallback(html, BODY_TAG_NAME).getElementsByTagName(BODY_TAG_NAME)[0].childNodes;
            }
            break;
    }

    return [];
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */
var domparser = __webpack_require__(45);
var utilities = __webpack_require__(10);
var formatDOM = utilities.formatDOM;
var isIE9 = utilities.isIE(9);

/**
 * Constants.
 */
var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>

/**
 * Parses HTML and reformats DOM nodes output.
 *
 * @param  {String} html - The HTML string.
 * @return {Array}       - The formatted DOM nodes.
 */
module.exports = function parseDOM(html) {
    if (typeof html !== 'string') {
        throw new TypeError('First argument must be a string.');
    }
    if (!html) return [];

    // match directive
    var match = html.match(DIRECTIVE_REGEX);
    var directive;
    if (match && match[1]) {
        directive = match[1];

        // remove directive in IE9 because DOMParser uses
        // MIME type 'text/xml' instead of 'text/html'
        if (isIE9) {
            html = html.replace(match[0], '');
        }
    }

    return formatDOM(domparser(html), null, directive);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var domToReact = __webpack_require__(49);
var htmlToDOM = __webpack_require__(46);

// decode HTML entities by default for `htmlparser2`
var domParserOptions = { decodeEntities: true, lowerCaseAttributeNames: false };

/**
 * Converts HTML string to React elements.
 *
 * @param  {String}   html              - The HTML string to parse to React.
 * @param  {Object}   [options]         - The parser options.
 * @param  {Function} [options.replace] - The replace method.
 * @return {ReactElement|Array|String}  - When parsed with HTML string, returns React elements; otherwise, returns string or empty array.
 */
function HTMLReactParser(html, options) {
  if (typeof html !== 'string') {
    throw new TypeError('First argument must be a string');
  }
  return domToReact(htmlToDOM(html, domParserOptions), options);
}

HTMLReactParser.domToReact = domToReact;
HTMLReactParser.htmlToDOM = htmlToDOM;

module.exports = HTMLReactParser;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var reactProperty = __webpack_require__(52);
var styleToObject = __webpack_require__(57);
var utilities = __webpack_require__(11);

var camelCase = utilities.camelCase;

var htmlProperties = reactProperty.html;
var svgProperties = reactProperty.svg;
var isCustomAttribute = reactProperty.isCustomAttribute;

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param  {Object} [attributes={}] - The HTML/SVG DOM attributes.
 * @return {Object}                 - The React props.
 */
function attributesToProps(attributes) {
  attributes = attributes || {};

  var attributeName;
  var attributeNameLowerCased;
  var attributeValue;
  var property;
  var props = {};

  for (attributeName in attributes) {
    attributeValue = attributes[attributeName];

    // ARIA (aria-*) or custom data (data-*) attribute
    if (isCustomAttribute(attributeName)) {
      props[attributeName] = attributeValue;
      continue;
    }

    // convert HTML attribute to React prop
    attributeNameLowerCased = attributeName.toLowerCase();
    if (hasOwnProperty.call(htmlProperties, attributeNameLowerCased)) {
      property = htmlProperties[attributeNameLowerCased];
      props[property.propertyName] =
        property.hasBooleanValue ||
        (property.hasOverloadedBooleanValue && !attributeValue)
          ? true
          : attributeValue;
      continue;
    }

    // convert SVG attribute to React prop
    if (hasOwnProperty.call(svgProperties, attributeName)) {
      property = svgProperties[attributeName];
      props[property.propertyName] = attributeValue;
      continue;
    }

    // preserve custom attribute if React >=16
    if (utilities.PRESERVE_CUSTOM_ATTRIBUTES) {
      props[attributeName] = attributeValue;
    }
  }

  // convert inline style to object
  if (attributes.style != null) {
    props.style = cssToJs(attributes.style);
  }

  return props;
}

/**
 * Converts CSS style string to JS style object.
 *
 * @param  {String} style - The CSS style.
 * @return {Object}       - The JS style object.
 */
function cssToJs(style) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string.');
  }

  var styleObj = {};

  styleToObject(style, function(property, value) {
    // skip if it's a comment node
    if (property && value) {
      styleObj[camelCase(property)] = value;
    }
  });

  return styleObj;
}

module.exports = attributesToProps;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var attributesToProps = __webpack_require__(48);
var utilities = __webpack_require__(11);

var cloneElement = React.cloneElement;
var createElement = React.createElement;
var isValidElement = React.isValidElement;

/**
 * Converts DOM nodes to React elements.
 *
 * @param  {Array}    nodes             - The DOM nodes.
 * @param  {Object}   [options]         - The additional options.
 * @param  {Function} [options.replace] - The replace method.
 * @return {ReactElement|Array}
 */
function domToReact(nodes, options) {
  options = options || {};
  var result = [];
  var node;
  var hasReplace = typeof options.replace === 'function';
  var replaceElement;
  var props;
  var children;

  for (var i = 0, len = nodes.length; i < len; i++) {
    node = nodes[i];

    // replace with custom React element (if present)
    if (hasReplace) {
      replaceElement = options.replace(node);

      if (isValidElement(replaceElement)) {
        // specify a "key" prop if element has siblings
        // https://fb.me/react-warning-keys
        if (len > 1) {
          replaceElement = cloneElement(replaceElement, {
            key: replaceElement.key || i
          });
        }
        result.push(replaceElement);
        continue;
      }
    }

    if (node.type === 'text') {
      result.push(node.data);
      continue;
    }

    props = node.attribs;
    if (!shouldPassAttributesUnaltered(node)) {
      // update values
      props = attributesToProps(node.attribs);
    }

    children = null;

    // node type for <script> is "script"
    // node type for <style> is "style"
    if (node.type === 'script' || node.type === 'style') {
      // prevent text in <script> or <style> from being escaped
      // https://facebook.github.io/react/tips/dangerously-set-inner-html.html
      if (node.children[0]) {
        props.dangerouslySetInnerHTML = {
          __html: node.children[0].data
        };
      }
    } else if (node.type === 'tag') {
      // setting textarea value in children is an antipattern in React
      // https://reactjs.org/docs/forms.html#the-textarea-tag
      if (node.name === 'textarea' && node.children[0]) {
        props.defaultValue = node.children[0].data;

        // continue recursion of creating React elements (if applicable)
      } else if (node.children && node.children.length) {
        children = domToReact(node.children, options);
      }

      // skip all other cases (e.g., comment)
    } else {
      continue;
    }

    // specify a "key" prop if element has siblings
    // https://fb.me/react-warning-keys
    if (len > 1) {
      props.key = i;
    }

    result.push(createElement(node.name, props, children));
  }

  return result.length === 1 ? result[0] : result;
}

function shouldPassAttributesUnaltered(node) {
  return (
    utilities.PRESERVE_CUSTOM_ATTRIBUTES &&
    node.type === 'tag' &&
    utilities.isCustomComponent(node.name, node.attribs)
  );
}

module.exports = domToReact;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

if (false) {
  var hot = require('./index').hot;
  if (module.hot) {
    var cache = require.cache;

    if (!module.parents || module.parents.length === 0) {
      throw new Error(
        'React-Hot-Loader: `react-hot-loader/root` is not supported on your system. ' +
        'Please use `import {hot} from "react-hot-loader"` instead'
      );
    }
    // access parent
    var parent = cache[module.parents[0]];
    if (!parent) {
      throw new Error(
        'React-Hot-Loader: `react-hot-loader/root` is not supported on your system. ' +
        'Please use `import {hot} from "react-hot-loader"` instead'
      );
    }
    // remove self from a cache
    delete cache[module.id];
  }
  // setup hot for caller
  exports.hot = hot(parent);
} else {
  // prod mode
  exports.hot = function (a) {
    return a;
  };
}


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var HTMLDOMPropertyConfig = __webpack_require__(53);
var SVGDOMPropertyConfig = __webpack_require__(54);
var injection = __webpack_require__(55);

var MUST_USE_PROPERTY = injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = injection.HAS_OVERLOADED_BOOLEAN_VALUE;

/**
 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L14-L16
 *
 * @param  {Number}  value
 * @param  {Number}  bitmask
 * @return {Boolean}
 */
function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

/**
 * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/DOMProperty.js#L57
 *
 * @param {Object}  domPropertyConfig - HTMLDOMPropertyConfig or SVGDOMPropertyConfig
 * @param {Object}  config            - The object to be mutated
 * @param {Boolean} isSVG             - Whether the injected config is HTML or SVG (it assumes the default is HTML)
 */
function injectDOMPropertyConfig(domPropertyConfig, config, isSVG) {
  var Properties = domPropertyConfig.Properties;
  var DOMAttributeNames = domPropertyConfig.DOMAttributeNames;
  var attributeName;
  var propertyName;
  var propConfig;

  for (propertyName in Properties) {
    attributeName =
      DOMAttributeNames[propertyName] ||
      (isSVG ? propertyName : propertyName.toLowerCase());
    propConfig = Properties[propertyName];

    config[attributeName] = {
      attributeName: attributeName,
      propertyName: propertyName,
      mustUseProperty: checkMask(propConfig, MUST_USE_PROPERTY),
      hasBooleanValue: checkMask(propConfig, HAS_BOOLEAN_VALUE),
      hasNumericValue: checkMask(propConfig, HAS_NUMERIC_VALUE),
      hasPositiveNumericValue: checkMask(
        propConfig,
        HAS_POSITIVE_NUMERIC_VALUE
      ),
      hasOverloadedBooleanValue: checkMask(
        propConfig,
        HAS_OVERLOADED_BOOLEAN_VALUE
      )
    };
  }
}

/**
 * HTML properties config.
 *
 * @type {Object}
 */
var html = {};
injectDOMPropertyConfig(HTMLDOMPropertyConfig, html);

/**
 * SVG properties config.
 *
 * @type {Object}
 */
var svg = {};
injectDOMPropertyConfig(SVGDOMPropertyConfig, svg, true);

/**
 * HTML and SVG properties config.
 *
 * @type {Object}
 */
var properties = {};
injectDOMPropertyConfig(HTMLDOMPropertyConfig, properties);
injectDOMPropertyConfig(SVGDOMPropertyConfig, properties, true);

var ATTRIBUTE_NAME_START_CHAR =
  ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR =
  ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';

module.exports = {
  html: html,
  svg: svg,
  properties: properties,

  /**
   * Checks whether a property name is a custom attribute.
   *
   * @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
   *
   * @param {String}
   * @return {Boolean}
   */
  isCustomAttribute: RegExp.prototype.test.bind(
    new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$')
  )
};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = {
  Properties: {
    autoFocus: 4,
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: 4,
    allowTransparency: 0,
    alt: 0,
    as: 0,
    async: 4,
    autoComplete: 0,
    autoPlay: 4,
    capture: 4,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: 5,
    cite: 0,
    classID: 0,
    className: 0,
    cols: 24,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: 4,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0,
    dateTime: 0,
    default: 4,
    defer: 4,
    dir: 0,
    disabled: 4,
    download: 32,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: 4,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: 4,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 4,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    multiple: 5,
    muted: 5,
    name: 0,
    nonce: 0,
    noValidate: 4,
    open: 4,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 4,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: 4,
    referrerPolicy: 0,
    rel: 0,
    required: 4,
    reversed: 4,
    role: 0,
    rows: 24,
    rowSpan: 8,
    sandbox: 0,
    scope: 0,
    scoped: 4,
    scrolling: 0,
    seamless: 4,
    selected: 5,
    shape: 0,
    size: 24,
    sizes: 0,
    span: 24,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: 8,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    property: 0,
    resource: 0,
    typeof: 0,
    vocab: 0,
    autoCapitalize: 0,
    autoCorrect: 0,
    autoSave: 0,
    color: 0,
    itemProp: 0,
    itemScope: 4,
    itemType: 0,
    itemID: 0,
    itemRef: 0,
    results: 0,
    security: 0,
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  }
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = {
  Properties: {
    accentHeight: 0,
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 0,
    allowReorder: 0,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 0,
    ascent: 0,
    attributeName: 0,
    attributeType: 0,
    autoReverse: 0,
    azimuth: 0,
    baseFrequency: 0,
    baseProfile: 0,
    baselineShift: 0,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 0,
    capHeight: 0,
    clip: 0,
    clipPath: 0,
    clipRule: 0,
    clipPathUnits: 0,
    colorInterpolation: 0,
    colorInterpolationFilters: 0,
    colorProfile: 0,
    colorRendering: 0,
    contentScriptType: 0,
    contentStyleType: 0,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 0,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 0,
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 0,
    elevation: 0,
    enableBackground: 0,
    end: 0,
    exponent: 0,
    externalResourcesRequired: 0,
    fill: 0,
    fillOpacity: 0,
    fillRule: 0,
    filter: 0,
    filterRes: 0,
    filterUnits: 0,
    floodColor: 0,
    floodOpacity: 0,
    focusable: 0,
    fontFamily: 0,
    fontSize: 0,
    fontSizeAdjust: 0,
    fontStretch: 0,
    fontStyle: 0,
    fontVariant: 0,
    fontWeight: 0,
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 0,
    glyphOrientationHorizontal: 0,
    glyphOrientationVertical: 0,
    glyphRef: 0,
    gradientTransform: 0,
    gradientUnits: 0,
    hanging: 0,
    horizAdvX: 0,
    horizOriginX: 0,
    ideographic: 0,
    imageRendering: 0,
    in: 0,
    in2: 0,
    intercept: 0,
    k: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    kernelMatrix: 0,
    kernelUnitLength: 0,
    kerning: 0,
    keyPoints: 0,
    keySplines: 0,
    keyTimes: 0,
    lengthAdjust: 0,
    letterSpacing: 0,
    lightingColor: 0,
    limitingConeAngle: 0,
    local: 0,
    markerEnd: 0,
    markerMid: 0,
    markerStart: 0,
    markerHeight: 0,
    markerUnits: 0,
    markerWidth: 0,
    mask: 0,
    maskContentUnits: 0,
    maskUnits: 0,
    mathematical: 0,
    mode: 0,
    numOctaves: 0,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 0,
    overlineThickness: 0,
    paintOrder: 0,
    panose1: 0,
    pathLength: 0,
    patternContentUnits: 0,
    patternTransform: 0,
    patternUnits: 0,
    pointerEvents: 0,
    points: 0,
    pointsAtX: 0,
    pointsAtY: 0,
    pointsAtZ: 0,
    preserveAlpha: 0,
    preserveAspectRatio: 0,
    primitiveUnits: 0,
    r: 0,
    radius: 0,
    refX: 0,
    refY: 0,
    renderingIntent: 0,
    repeatCount: 0,
    repeatDur: 0,
    requiredExtensions: 0,
    requiredFeatures: 0,
    restart: 0,
    result: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    seed: 0,
    shapeRendering: 0,
    slope: 0,
    spacing: 0,
    specularConstant: 0,
    specularExponent: 0,
    speed: 0,
    spreadMethod: 0,
    startOffset: 0,
    stdDeviation: 0,
    stemh: 0,
    stemv: 0,
    stitchTiles: 0,
    stopColor: 0,
    stopOpacity: 0,
    strikethroughPosition: 0,
    strikethroughThickness: 0,
    string: 0,
    stroke: 0,
    strokeDasharray: 0,
    strokeDashoffset: 0,
    strokeLinecap: 0,
    strokeLinejoin: 0,
    strokeMiterlimit: 0,
    strokeOpacity: 0,
    strokeWidth: 0,
    surfaceScale: 0,
    systemLanguage: 0,
    tableValues: 0,
    targetX: 0,
    targetY: 0,
    textAnchor: 0,
    textDecoration: 0,
    textRendering: 0,
    textLength: 0,
    to: 0,
    transform: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 0,
    underlineThickness: 0,
    unicode: 0,
    unicodeBidi: 0,
    unicodeRange: 0,
    unitsPerEm: 0,
    vAlphabetic: 0,
    vHanging: 0,
    vIdeographic: 0,
    vMathematical: 0,
    values: 0,
    vectorEffect: 0,
    version: 0,
    vertAdvY: 0,
    vertOriginX: 0,
    vertOriginY: 0,
    viewBox: 0,
    viewTarget: 0,
    visibility: 0,
    widths: 0,
    wordSpacing: 0,
    writingMode: 0,
    x: 0,
    xHeight: 0,
    x1: 0,
    x2: 0,
    xChannelSelector: 0,
    xlinkActuate: 0,
    xlinkArcrole: 0,
    xlinkHref: 0,
    xlinkRole: 0,
    xlinkShow: 0,
    xlinkTitle: 0,
    xlinkType: 0,
    xmlBase: 0,
    xmlns: 0,
    xmlnsXlink: 0,
    xmlLang: 0,
    xmlSpace: 0,
    y: 0,
    y1: 0,
    y2: 0,
    yChannelSelector: 0,
    z: 0,
    zoomAndPan: 0
  },
  DOMAttributeNames: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDasharray: 'stroke-dasharray',
    strokeDashoffset: 'stroke-dashoffset',
    strokeLinecap: 'stroke-linecap',
    strokeLinejoin: 'stroke-linejoin',
    strokeMiterlimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    xlinkActuate: 'xlink:actuate',
    xlinkArcrole: 'xlink:arcrole',
    xlinkHref: 'xlink:href',
    xlinkRole: 'xlink:role',
    xlinkShow: 'xlink:show',
    xlinkTitle: 'xlink:title',
    xlinkType: 'xlink:type',
    xmlBase: 'xml:base',
    xmlnsXlink: 'xmlns:xlink',
    xmlLang: 'xml:lang',
    xmlSpace: 'xml:space'
  }
};


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = {
  MUST_USE_PROPERTY: 1,
  HAS_BOOLEAN_VALUE: 4,
  HAS_NUMERIC_VALUE: 8,
  HAS_POSITIVE_NUMERIC_VALUE: 24,
  HAS_OVERLOADED_BOOLEAN_VALUE: 32
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(50);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = DDC.WsmCommonData;

/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = ReactDOM;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = Redux;

/***/ }),
/* 61 */
/***/ (function(module, exports) {

module.exports = ReduxThunk;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(13);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.bd2dfa955584a8597f37.js